import $ from "jquery/dist/jquery";
import lightbox2 from "lightbox2";

import "lightbox2/src/css/lightbox.css";

$(() => {
  lightbox2.option({
    albumLabel: "Obrázek %1 z %2",
  });
});
